function transformRatingHeadings() {
  var headings = document.querySelectorAll(".tt-c-ratings-breakdown__heading");
  var transformed = 0;
  headings.forEach(function (el) {
    var text = el.innerText.trim();
    var match = text.match(/^(\d[\d,]*)(\s+Ratings?)?$/i);
    if (match) {
      el.innerText = "(" + match[1] + ")";
      transformed++;
    }
  });
  return transformed;
}

function watchAndTransform() {
  if (transformRatingHeadings() > 0) return;

  var observer = new MutationObserver(function () {
    if (transformRatingHeadings() > 0) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

watchAndTransform();

window.matchMedia("(max-width: 750px)").addEventListener("change", function () {
  watchAndTransform();
});
